export default "__VITE_ASSET__CgAaPBnN__"